<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        退货合同
      </div>
      <div class="rj-page-card__content">
        <el-form ref="form" :model="info" :rules="rules" class="baseInfoForm">
          <div class="rj-row">
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  项目名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rprojectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rcreatedTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电子商务合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rnewContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原订单合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.roldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rcontractType }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位电话(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyPhone }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rorderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位电话(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rorderUnitTel }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rfinalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户签约类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rdistributorSignType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesArea }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rintegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rIntegratorSignType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域商务专员：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rassistantName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rpreSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  销售名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  部门：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesPersonDeptName }}
                </div>
              </div>
            </div>
            <div v-if="this.$route.query.contratType==='退货合同'">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退票方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rrefundInvoiceTypeName }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    物流公司：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rlogisticsCompanyName }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    物流单号：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rlogisticsNum }}
                  </div>
                </div>
              </div>
              <div class="rj-col-66">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退票收件地址：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rreceivingAddress }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    红色发票信息表编号：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rinvoiceRedNum }}
                  </div>
                </div>
              </div>
              <div class="rj-col-1">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退还返利金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.orderUnit }}
                  </div>
                </div>
              </div>

              <div class="rj-col-1">
                <el-form-item prop="info.rsupplementalTerm" label="补充条款:">
                  <el-input v-model.trim="info.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
                </el-form-item>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="info.rremarks" label="备注说明:">
                  <el-input v-model.trim="info.rremarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
                </el-form-item>
              </div>
            </div>
            <div v-if="this.$route.query.contratType==='虚拟退货合同'">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退票方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rrefundInvoiceType }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    物流公司：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rlogisticsCompanyName }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    物流单号：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rlogisticsNum }}
                  </div>
                </div>
              </div>
              <div class="rj-col-66">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退票收件地址：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rreceivingAddress }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    红色发票信息表编号：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ info.rinvoiceRedNum }}
                  </div>
                </div>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="info.rsupplementalTerm" label="补充条款:">
                  <el-input v-model.trim="info.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
                </el-form-item>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="info.rremarks" label="备注说明:">
                  <el-input v-model.trim="info.rremarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      rules: {}
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted () {
  }
};
</script>

<style lang='scss'>
.exchangeBaseInfo{
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
